/*
  Legacy global asset retained while Lane A owns script wiring.
  Any stale <size-finder> markup is converted to a non-recommending help state;
  the versioned implementation lives in lg-fit.js and <lg-fit-panel>.
*/

if (typeof window !== 'undefined' && window.customElements && !window.customElements.get('size-finder')) {
  class LegacySizeFinder extends HTMLElement {
    connectedCallback () {
      if (this.initialized) return
      this.initialized = true
      this.querySelectorAll('input, button, select').forEach(control => {
        control.disabled = true
      })
      const results = this.querySelector('.sg-finder-results, [role="status"]')
      if (results) {
        results.textContent = 'Automatic size matching is unavailable until a verified, versioned chart is approved. Use the fit guide or contact the studio for help.'
        results.removeAttribute('hidden')
      }
    }
  }

  window.customElements.define('size-finder', LegacySizeFinder)
}
